import { createFileRoute, redirect } from "@tanstack/react-router";
import { CreditCard } from "lucide-react";
import { z } from "zod";

import { sdk } from "@/api/sdk";
import { PageShell } from "@/components/layouts/shells/page-shell";
import { BillingOverview } from "@/features/billing/modules/billing-overview/billing-overview";
import { CheckoutSuccess } from "@/features/billing/modules/checkout-success/checkout-success";
import { hasPermissionInList } from "@/features/navigation/filter-nav-entries";
import { m } from "@/paraglide/messages.js";
import { PermissionAction, PermissionSubject } from "@complete-athlete/enums";

export const Route = createFileRoute("/(private)/billing/")({
  beforeLoad: async () => {
    const { data } = await sdk.users.me.$get.send();
    const permissions = data?.permissions ?? null;

    if (!hasPermissionInList(permissions, PermissionAction.MANAGE, PermissionSubject.BILLING)) {
      throw redirect({ to: "/" });
    }
  },
  component: RouteComponent,
  loader: () => {
    return {
      crumb: m.billing_nav_label(),
    };
  },
  validateSearch: z.object({
    checkout: z.literal("success").optional(),
  }),
});

function RouteComponent() {
  return (
    <div className="w-full space-y-10">
      <CheckoutSuccess />
      <PageShell icon={CreditCard} title={m.billing_page_title()} description={m.billing_page_description()}>
        <BillingOverview />
      </PageShell>
    </div>
  );
}
